import Config from 'Config';
import aws4 from 'aws4';

export default async function setEditBulletin(bulletin, params) {
  let projectId = bulletin.project.id || bulletin.project;
  const saveBulletin = { ...bulletin, project: projectId };
  if (!projectId) return console.error('Project ID is not defined');

  const apiPath = `projects/${projectId}/edit-bulletin`;

  const request = {
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(saveBulletin),
  };
  const signer = new aws4.RequestSigner(request, {
    accessKeyId: params.accessKeyId,
    secretAccessKey: params.secretAccessKey,
    sessionToken: params.sessionToken,
  });
  const signedRequest = signer.sign();
  signedRequest.headers.Accept = '*/*';

  const response = await fetch(
    `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    signedRequest
  ).then((res) => res.json());
  return response;
}
